import React from 'react';
import PropTypes from 'prop-types';

import ContentView from './ContentView';
import ContentEdit from './ContentEdit';

const Content = (props) => {
  const mode = props.mode;
  const extraFileMenuItems = props.extraFileMenuItems.reduce((prev, cur) => {
    if (cur) {
      return [...prev, cur];
    } else {
      return prev;
    }
  }, []);

  if (mode === 'VIEW') {
    return (
      <ContentView
        {...props}
        extraFileMenuItems={extraFileMenuItems}
      />
    );
  } else if (mode === 'EDIT') {
    return (
      <ContentEdit
        {...props}
        extraFileMenuItems={extraFileMenuItems}
      />
    );
  } else {
    return null;
  }
};

Content.propTypes = {
  mode: PropTypes.string.isRequired,
  extraFileMenuItems: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      handler: PropTypes.func.isRequired,
      Icon: PropTypes.elementType,
      condition: PropTypes.func,
    }),
  ])),
};

export default Content;
